import { Flex, Grid } from '@lifechurch/react-ion';
import styled from 'styled-components';

export const TableRowWrapper = styled(Grid)<{ isInvite: boolean }>`
  padding: ${props => props.theme.space[3]}px ${props => props.theme.space[5]}px
    ${props => props.theme.space[3] + 1}px ${props => props.theme.space[5]}px;
  align-items: center;
  cursor: pointer;
  grid-template-columns: 16px 150px repeat(4, 1fr) ${props =>
      props.isInvite ? '208px' : '80px 80px 15px'};
  grid-column-gap: 1rem;
  position: relative;

  &:not(:last-child):after {
    position: absolute;
    bottom: 0;
    left: ${props => props.theme.space[5]}px;
    right: ${props => props.theme.space[5]}px;
    display: block;
    height: 1px;
    content: '';
    background-color: ${props => props.theme.colors.gray10};
  }

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  p:not(:first-of-type) {
    color: ${props => (props.isInvite ? props.theme.colors.gray50 : props.theme.colors.gray80)};
  }

  &:hover {
    background-color: ${props => props.theme.colors.action.light};
    & > p,
    div svg path {
      color: ${props => props.theme.colors.gray100};
    }

    & > p:nth-child(2) {
      color: ${props => props.theme.colors.action.hover};
      fill: ${props => props.theme.colors.action.hover};
    }

    &:after {
      display: none;
    }

    &:not(:first-child) {
      box-shadow: 0px -1px ${props => props.theme.colors.action.light};
    }
  }
`;

export const HeaderItemWrapper = styled(Flex)`
  align-items: center;
  cursor: default;
  font-weight: 600;
`;
